import * as Actions from './actions/actions';
import { settings } from '@alme/ui-web/settings/settings-util';
import reducer from './reducers/index';
//@ts-ignore
import * as postMessageUtilities from '@alme/ui-web/modules/lib-postmessage/lib/lib-postmessage';
//@ts-ignore
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';

/**
 * ChangeRoleIdProcessor is responsible for processing the roleId message
 * received from the ClientCommunicator. It also removes the message after it is processed.
*/
export default class ChangeRoleIdProcessor
{
    _settings: typeof settings;
    _store: Store<AlmeState> | undefined;
    constructor(passedSettings: typeof settings)
    {
        this._settings = passedSettings || settings;
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getReducer()
    {
        return reducer;
    }

    initialize(store: Store<AlmeState>)
    {
        this._store = store;

        postMessageUtilities.setupStateWatchForReceivedMessages(this._settings, this._store, this.processRoleId.bind(this));
    }

    processRoleId(newVal: any)
    {
        const msg = postMessageUtilities.getAndValidateMessage(newVal, 'roleidchange');
        if (msg === null)
        {
            return;
        }

        if(this._store) {
            let roleId = "";
            if(msg.message && msg.message.Data && msg.message.Data.roleId) {
                roleId = msg.message.Data.roleId;
            }

            let stateLocation;

            if(window.enableIVAasService){
                //TODO: determine how to handle ALIGHT specific settings

                //@ts-ignore
                const initDataBaseLocation  = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.initializationData.Base}`;
                //@ts-ignore
                const metadataBaseLocation = this._settings.stateLocations.Window.initializationData.metadata.Base;
                //@ts-ignore
                const roleIdLocation = this._settings.stateLocations.Window.initializationData.metadata.roleId;

                stateLocation = `${initDataBaseLocation}.${metadataBaseLocation}.${roleIdLocation}`;
            } else {
                const windowBase = this._settings.stateLocations.Window.Base;
                //@ts-ignore
                const productPayloadBase = this._settings.stateLocations.Window.productPayload.Base;
                //@ts-ignore
                const generalConfigDataBase =  this._settings.stateLocations.Window.productPayload.generalConfigData.Base;
                //@ts-ignore
                const roleIdLocation =  this._settings.stateLocations.Window.productPayload.generalConfigData.roleId;

                stateLocation = `${windowBase}.${productPayloadBase}.${generalConfigDataBase}.${roleIdLocation}`;
            }

            this._store.dispatch(Actions.updateRoleId({stateLocation, roleId}));
        }
    }
}



// WEBPACK FOOTER //
// ./modules/role-id-window-post/changeRoleIdProcessor.ts